import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PosPage from "PosPage";
import { MainLayout } from "./layout/MainLayout";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<PosPage/>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
